// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const reelsLikesHistoryConfig = {
    title: 'chart.instagram.reels.reels_likes_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.instagram.reels.reels_likes_history_name',
        avg: 'chart.instagram.reels.reels_likes_history_avg'
    },
    id: 'reels_likes_history',
    color: {
        value: 'red',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.instagram.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueColors: [
        'orange',
        'green',
        'blue',
        'red',
        'yellow',
        'purple',
        'pink',
        'aquablue',
        'lightBlue',
        'black',
        'lightaquablue',
        'lightgreen',
        'lightyellow',
        'lightpurple',
        'lightpink',
        'lightorange'
    ],
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'chart.instagram.reels.reels_likes_history_tooltip',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
